// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonObjectCreate/style.css
// module id = 2842
// module chunks = 29